<template>
  <div class="px-0">
    <div class="d-flex justify-space-between align-center">
      <div style="flex: 1 1 40%">
      <v-card-title class="text-h4 font-weight-bold mb-n3">
        {{ $t("dashboard.firstTitle") }}
      </v-card-title>
    </div>
      <CalendarPicker @update-calendar="filter.date.dates = $event" :snap="filter.date.dates"></CalendarPicker>
      <div style="flex: 1 1 40%">
</div>
    </div>
    <v-row class="mb-8 px-2">
      <!-- <div>
        <ul>
          <li v-for="item in items" :key="item.id">{{ item }}</li>
        </ul>
      </div> -->
      <v-col cols="12" md="12 " class="px-6">
        <v-card class="pa-6" outlined>

          <div class="d-flex justify-space-between">
            <div class="py-3" style="flex: 1 1 33%">
              <template v-if="!loading">
                <div class="text-subtitle-2 font-weight-bold">
                  {{ $t("dashboard.todayRevenue") }}
                </div>
                <div class="text-h4 font-weight-bold pt-3">
                  {{ $n(ordersData.totals.valueToday, "currency") }}
                </div>
                <div class="text-caption">
                  <span class="grey--text lighten-2" v-html="$tc('dashboard.orders', ordersData.totals.countToday, {
                    count: ordersData.totals.countToday,
                  })
                    ">
                  </span>
                </div>
              </template>
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>
            </div>
            <v-divider vertical class="mx-6"></v-divider>

            <div class="py-3" style="flex: 1 1 33%">
              <template v-if="!loading">
                <div class="text-subtitle-2 font-weight-bold">
                  {{ $t("dashboard.periodRevenue") }}
                </div>
                <div class="text-h4 pt-3 font-weight-bold">
                  {{ $n(ordersData.totals.valuePeriod, "currency") }}
                </div>
                <div class="text-caption">
                  <span class="grey--text lighten-2" v-html="$tc('dashboard.orders', ordersData.totals.countPeriod, {
                    count: ordersData.totals.countPeriod,
                  })
                    ">
                  </span>
                </div>
              </template>
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>
            </div>
            <v-divider vertical class="mx-6"></v-divider>
            <div class="py-3" style="flex: 1 1 33%">
              <template v-if="!loading">
                <div class="text-subtitle-2 font-weight-bold">
                  {{ $t("dashboard.totalRevenue") }}
                </div>
                <div class="text-h4 font-weight-bold pt-3">
                  {{ $n(biPayment.finalPaid, "currency") }}
                </div>
                <div class="text-caption">
                  <span class="grey--text lighten-2" v-html="$tc('dashboard.orders', biPayment.count, {
                    count: biPayment.count,
                  })
                    ">
                  </span> 
                </div>
                <!-- <div class="text-caption">
                    <span class="blue--text font-weight-medium">{{
                      $t("dashboard.payout")
                    }}</span>
                    <span class="grey--text lighten-2">
                      <strong>{{
                        $n(ordersData.totals.paymentSoon, "currency")
                      }}</strong>
                      {{ $t("dashboard.payoutValue") }}</span
                    >
                  </div> -->
              </template>
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>
            </div>
          </div>

          <v-divider class="my-9"></v-divider>
          <v-card elevation="0">
            <div class="d-flex mt-n3" v-if="!loading">
              <v-spacer></v-spacer>
              <v-btn-toggle mandatory v-model="historicType">
                <v-btn>
                  {{ $t('dashboard.history')}}
                </v-btn>
                <v-btn>
                  {{ $t('dashboard.current')}}
                </v-btn>
              </v-btn-toggle>
              <div class="px-6"></div>
              <v-btn-toggle mandatory v-model="undistinct">
                <v-btn>
                  {{ $t('dashboard.users')}}
                </v-btn>
                <v-btn>
                  {{ $t('dashboard.transaction')}}
                </v-btn>
              </v-btn-toggle>
              <!-- <v-switch v-model="undistinct" :label="undistinct ? 'Transaciones' : 'Usuários'"></v-switch> -->
              <v-spacer></v-spacer>

            </div>
            <v-row class="justify-center --box" v-if="!loading">
              <v-col class="" cols="12" md="12" sm="12" v-if="!funnelLoading">
                <v-card elevation="0" outlinned>
                  <div class="vue-funnel-graph-lib-dev">
                    <div class="funnels mt-6 mb-12" :style="`height: ${height + 80}px`">
                      <vue-funnel-graph :displayPercentage="false" :width="funnelWidth" class="" :height="height"
                        :labels="labels" :values="funnelData" :colors="colors" :sub-labels="subLabels"
                        :direction="direction" :gradient-direction="gradientDirection" :animated="true"
                        :display-percentage="true"></vue-funnel-graph>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-skeleton-loader v-else type="image" height="300px"></v-skeleton-loader>
          </v-card>
          <v-divider class="mt-3 mb-9"></v-divider>
          <div class="d-flex justify-start">
            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="result.users" :label="$t('dashboard.unique visitors')"
                info="(Google Analytics)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>

            <v-divider vertical class="mx-6"></v-divider>
            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="result.newUsers" :label="$t('dashboard.newVisitors')"
                info="(Google Analytics)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
            <v-divider vertical class="mx-6"></v-divider>
            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="result.sessions" :label="$t('dashboard.sessions')"
                info="(Google Analytics)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>
            </div>
            <v-divider vertical class="mx-6"></v-divider>
            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="storeData.register" :label="$t('dashboard.newRegisters')"
                info="(The Media Trade)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
          </div>
          <v-divider class="my-9"></v-divider>

          <div class="d-flex justify-start">
            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="storeData.login" :label="$t('dashboard.logins')"
                info="(The Media Trade)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
            <v-divider vertical class="mx-6"></v-divider>

            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :currency="true" :data-chart="ordersData.result.paidValue"
                :label="$t('dashboard.grossIncome')" info="(The Media Trade)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
            <v-divider vertical class="mx-6"></v-divider>

            <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph v-if="!loadingOtherData" :data-chart="ordersData.result.paid"
                :label="$t('dashboard.transactions')" info="(The Media Trade)" />
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
            <v-divider vertical class="mx-6"></v-divider>
            <!-- <div style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <DashGraph
                :data-chart="ordersData.result.averageTicket"
                :label="$t('dashboard.averageTicket')"
                info="(The Media Trade)"
              />
            </div> -->
            <div class="align-center" style="flex: 0 1 25%; flex-basis: calc(25% - 34.5px)">
              <template v-if="!loadingOtherData">
                <div class="font-weight-bold">
                  {{ $t("dashboard.averageTicket") }}
                </div>
                <div class="text-h5 font-weight-bold pt-3">
                  {{ $n(averageTicket, "currency") }}
                </div>
                <div class="text-caption"></div>
              </template>
              <v-skeleton-loader v-else type="article"></v-skeleton-loader>

            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DashGraph from "@/components/googleChart/dashGraph/DashGraph.vue";
import CalendarPicker from "@/interface/CalendarPicker.vue"
import config from "@/store/config";
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

import { VueFunnelGraph } from "vue-funnel-graph-js-fixed-node-sass-dep";

import { mapState } from "vuex";

import moment from "moment";

export default {
  components: {
    DashGraph,
    VueFunnelGraph,
    CalendarPicker
  },
  data() {
    return {
      biPayment: {},
      historicType: 0,
      steps: {
        plan: ['planning', 'processing', 'waiting_payment', 'waiting_quotation', 'payment', 'content', 'paid', 'content_reproved', 'content_approved', 'awaiting_content_approval', 'waiting_content', 'content_partially_reproved', 'refused', 'placement', 'waiting_placement', 'on_placement', 'placement_error', 'finish', 'waiting_pi_approval', 'done', 'waiting_document', 'documents_sent', 'finish_placement'],
        checkout: ['waiting_payment', 'overdue_payment', 'processing', 'waiting_quotation', 'payment', 'content', 'paid', 'content_reproved', 'content_approved', 'awaiting_content_approval', 'waiting_content', 'content_partially_reproved', 'refused', 'placement', 'waiting_placement', 'waiting_pi_approval', 'on_placement', 'placement_error', 'finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement'],
        payment: ['content', 'paid', 'content_reproved', 'content_approved', 'awaiting_content_approval', 'waiting_content', 'content_partially_reproved', 'refused', 'placement', 'waiting_placement', 'waiting_pi_approval', 'on_placement',  'placement_error', 'finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement'],
        placement: ['placement', 'waiting_placement', 'on_placement', 'placement_error', 'finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement'],
        finish: ['finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement']
      },
      stepsCurrent: {
        plan: ['planning'],
        checkout: ['waiting_payment', 'waiting_quotation', 'overdue_payment', 'payment', 'processing'],
        payment: ['content', 'paid', 'content_reproved', 'content_approved', 'awaiting_content_approval', 'waiting_content', 'content_partially_reproved', 'waiting_pi_approval', 'refused'],
        placement: ['placement', 'waiting_placement', 'on_placement', 'placement_error'],
        finish: ['finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement']
      },

      undistinct: this.$route.query.undistinct ? this.$route.query.undistinct : false,
      contador: 0,
      orders: [],
      loading: false,
      loadingOtherData: false,
      funnelLoading: true,
      funnelWidth: 500,
      newDates: [],
      result: [],
      filter: {
        date: {
          menu: false,
          dates: [
            moment().subtract(1, "month").format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD"),
          ],
        },
      },
      labels: [
        "",
        "",
        "",
        "",
        "",
        ""
      ],
      subLabels: ["Funíl"],
      values: [[0], [0], [0], [0], [0], [0]],
      colors: [
        ["#233975", "#233975"], // color set for "Impressions" segment
      ],
      direction: "horizontal",
      gradientDirection: "120",
      height: 350,
      width: 900,
      dataSetNum: 1,
      subLabelValue: "percent",
      items: [],
      documents: [],
    };
  },

  computed: {
    ...mapState("groupStores", ["selectedStore"]),

    averageTicket() {






      const grossRevenue = this.ordersData.result.paidValue.values.reduce(
        (acc, curr) => acc + curr,
        0
      );
      if (!isNaN(grossRevenue / this.ordersData.totals.countPeriod)) {
        return grossRevenue / this.ordersData.totals.countPeriod;
      } else {
        return 0;
      }
    },

    defaultDates() {
      const fromDate = moment(this.filter.date.dates[0], "YYYY-MM-DD").subtract(
        1,
        "day"
      );
      const toDate = moment(this.filter.date.dates[1], "YYYY-MM-DD").add(
        1,
        "day"
      );
      const diff = toDate.diff(fromDate, "days");
      console.log("diff", diff);
      const result = {
        dates: [],
        values: [],
      };
      for (let i = 0; i < diff; i++) {
        const date = fromDate.add(1, "day").format("YYYY-MM-DD");
        console.log("date", date);
        result.dates.push(date);
        result.values.push(0);
      }
      return result;
    },
    dateRangeText() {
      let datesSelected = this.filter.date.dates;
      let dates = [];
      if (datesSelected.length) {
        dates.push(moment(datesSelected[0]).format("l"));
        if (datesSelected.length > 1)
          dates.push(moment(datesSelected[1]).format("l"));
      }

      return dates.join(`  ${this.$t("common.to")} `);
    },
    ordersData() {
      const totals = {
        paymentSoon: 0,
        paymentAvailable: 0,
        valueToday: 0,
        countToday: 0,
        valuePeriod: 0,
        countPeriod: 0,
      };
      const keys = [
        "averageTicket",
        "transactions",
        "login",
        "amount",
        "plans",
        "checkout",
        "paid",
        "done",
        "plansValue",
        "checkoutValue",
        "paidValue",
        "placement",
        "placementValue",
        "doneValue",
      ];
      const res = {};
      const dates = {};
      keys.forEach((key) => {
        res[key] = {
          values: [],
          labels: [],
          sum: 0
        };
        dates[key] = {};
      });
      const fromDate = moment(this.filter.date.dates[0], "YYYY-MM-DD").subtract(
        1,
        "day"
      );
      const toDate = moment(this.filter.date.dates[1], "YYYY-MM-DD").add(
        1,
        "day"
      );
      const allowDates = []
      const diff = toDate.diff(fromDate, "days");
      for (let i = 0; i < diff; i++) {
        const date = fromDate.add(1, "day").format("YYYY-MM-DD");
        keys.forEach((key) => {
          allowDates.push(date)
          dates[key][date] = 0;
        });
      }
      const selectedStoreOrdes = this.orders
      console.log('selectedStoreOrdes', selectedStoreOrdes)
      const sum = {
        login: [],
        plans: [],
        paid: [],
        checkout: [],
        payment: [],
        placement: [],
        checking: [],
        done: []
      }
      const funnelSum = {
        login: 0,
        plans: 0,
        paid: 0,
        checkout: 0,
        payment: 0,
        placement: 0,
        checking: 0,
        done: 0
      }
      const typeToCheck = this.historicType == 0 ? 'steps' : 'stepsCurrent'
      const undistinct = this.undistinct

      selectedStoreOrdes.forEach((doc) => {
        let kAllowDates = moment(doc.updatedOn).format('YYYY-MM-DD')
        if (allowDates.includes(kAllowDates)) {
          console.log('D o C', doc)
                console.log('Sum.plans', sum.plans)
          if (doc.hasOwnProperty('total') || doc.status == 'planning') {
            const docDate = moment(doc.updatedOn).format("YYYY-MM-DD");
            console.log('doc.status', doc.status)

            if (dates.plans.hasOwnProperty(docDate)) {
              
              if (doc.hasOwnProperty("status") && this[typeToCheck].plan.includes(doc.status)) {
                dates.plans[docDate]++;
                
                if (!sum.plans.includes(doc.user.uid) || undistinct) {
                  sum.plans.push(doc.user.uid)
                  funnelSum.plans++;
                }
                dates.plansValue[docDate] += doc.hasOwnProperty('total') && doc.total.hasOwnProperty('final') ? doc.total.final : 0
              }
            }
              if (doc.hasOwnProperty("status") && this[typeToCheck].finish.includes(doc.status)) {
                dates.done[docDate]++;
                if (!sum.done.includes(doc.user.uid) || undistinct) {
                  sum.done.push(doc.user.uid)
                  funnelSum.done++;

                }
                dates.doneValue[docDate] += doc.total.final
              }
             
              if (doc.hasOwnProperty("status") && doc.status == "done") {
                // payment available
                if (doc.total.availableToPay) {
                  totals.paymentSoon += doc.total.final;
                }
              }
              if (doc.hasOwnProperty("status") && doc.status == "done") {
                if (!doc.total.availableToPay) {
                  totals.paymentAvailable += doc.total.final;
                }
              }
              console.log('doc.status', doc.id, doc.status)
              let arr = ['content', 'paid', 'content_reproved', 'planning','processing', 'content_approved', 'awaiting_content_approval',  'waiting_pi_approval', 'waiting_content', 'content_partially_reproved', 'placement', 'waiting_placement', 'on_placement', 'placement_error','finish', 'done', 'waiting_document', 'documents_sent', 'finish_placement']
            if (arr.includes(doc.status) && doc.hasOwnProperty('total') && doc.total.hasOwnProperty('final')){
                dates.paidValue[docDate] += doc.total.final
                if(doc.paymentInfo && doc.paymentInfo.paymentDetect){
                  totals.valueToday +=
                    moment(doc.paymentInfo.paymentDetect).format('YYYY-MM-DD') == moment().format("YYYY-MM-DD") && doc.total.final
                      ? doc.total.final
                      : 0;
                  totals.countToday +=
                    moment(doc.paymentInfo.paymentDetect).format('YYYY-MM-DD') == moment().format("YYYY-MM-DD") && doc.total && doc.total.final ? 1 : 0;
                  totals.valuePeriod += doc.total && doc.total.final
                    ? parseFloat(doc.total.final) : 0
                  totals.countPeriod += 1;
                }
                else{
                  totals.valueToday +=
                    moment(doc.createdOn).format('YYYY-MM-DD') == moment().format("YYYY-MM-DD") && doc.total.final
                      ? doc.total.final
                      : 0;
                  totals.countToday +=
                    moment(doc.createdOn).format('YYYY-MM-DD') == moment().format("YYYY-MM-DD") && doc.total && doc.total.final ? 1 : 0;
                  totals.valuePeriod += doc.total && doc.total.final
                    ? parseFloat(doc.total.final) : 0
                  totals.countPeriod += 1;
                }


                dates.paid[docDate]++;
                if(doc.hasOwnProperty("status") && this[typeToCheck].payment.includes(doc.status))
                if (!sum.paid.includes(doc.user.uid) || undistinct) {
                  sum.paid.push(doc.user.uid)
                  funnelSum.paid++;
                }
              }



            // }


            if (dates.checkout.hasOwnProperty(docDate)) {
              if (
                doc.hasOwnProperty("status") && this[typeToCheck].checkout.includes(doc.status)) {
                dates.checkout[docDate]++;
                if (!sum.checkout.includes(doc.user.uid) || this.undistinct) {
                  sum.checkout.push(doc.user.uid)
                  funnelSum.checkout++;
                }
                dates.checkoutValue[docDate] += doc.total && doc.total.final ? doc.total.final : 0;
              }
            }
            if (dates.placementValue.hasOwnProperty(docDate)) {
              if (
                doc.hasOwnProperty("status") && this[typeToCheck].placement.includes(doc.status)) {
                dates.placement[docDate]++;
                if (!sum.placement.includes(doc.user.uid) || this.undistinct) {
                  sum.placement.push(doc.user.uid)
                  funnelSum.placement++;

                }
                dates.placementValue[docDate] += doc.total && doc.total.final ? doc.total.final : 0;
              }
            }
          }
          // if (dates.checkout.hasOwnProperty(docDate)) {
          //   if (doc.hasOwnProperty("status") && doc.status == "paid") {
          //     dates.paid[docDate]++;
          //     dates.paidValue[docDate] += this.calcPlanValue(doc);
          //   } 
          // }
        }

      });

      keys.forEach((key) => {
        for (let n in dates[key]) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          res[key].labels.push(new Date(parseInt(nDate)));
          res[key].values.push(dates[key][n]);

        }

      });

      return { result: res, totals: totals, funnel: funnelSum };
    },
    funnelData() {
      const chartData = [[0], [0], [0], [0], [0], [0]];
      this.storeData.login.values.forEach((data) => {
        chartData[0][0] += parseInt(data);
      });
      chartData[1][0] = this.ordersData.funnel.plans
      chartData[2][0] = this.ordersData.funnel.checkout
      chartData[3][0] = this.ordersData.funnel.paid
      chartData[4][0] = this.ordersData.funnel.placement
      chartData[5][0] = this.ordersData.funnel.done
      // this.ordersData.result.plans.values.forEach((data) => {
      //   chartData[1][0] += parseInt(data);
      // });
      // this.ordersData.result.checkout.values.forEach((data) => {
      //   chartData[2][0] += parseInt(data);
      // });
      // this.ordersData.result.paid.values.forEach((data) => {
      //   chartData[3][0] += parseInt(data);
      // });
      // this.ordersData.result.placement.values.forEach((data) => {
      //   chartData[4][0] += parseInt(data);
      // });
      // this.ordersData.result.done.values.forEach((data) => {
      //   chartData[5][0] += parseInt(data);
      // });
      return chartData;
    },
    storeData() {
      const keys = ["login", "register"]; //cria as keys login e register que sao duas strings dentro de um array
      const res = {}; // define uma cosnt res como objeto
      const dates = {}; // define uma const dates como objeto
      keys.forEach((key) => {
        //pra cada string lá dentro do array keys
        res[key] = {
          // pega o objeto vazio res e atribui a key como seu indicie
          values: [], // alem disso dentro dele atribui duas novas propriedades 'values e lables' que são arrays vazios
          labels: [],
        };
        //console.log('res', res[key] = {values:[],labels:[]})
        dates[key] = {}; //  pega o objeto vazio dates e artibui a key como seu indice
      });
      const fromDate = moment(this.filter.date.dates[0], "YYYY-MM-DD").subtract(
        // pegaa primeira data do filtro e tira um dia
        1,
        "day"
      );
      const toDate = moment(this.filter.date.dates[1], "YYYY-MM-DD").add(
        // pega a segunda data do filtro e tira um dia
        1,
        "day"
      );
      const from_Date = moment(fromDate).format('YYYY-MM-DD')
      const to_Date =  moment(toDate).format('YYYY-MM-DD')
      const diff = toDate.diff(fromDate, "days"); // pega o range de dia entre as duas datas do filtro
      for (let i = 0; i < diff; i++) {
        // enquanto estiver nesse rangge
        const date = fromDate.add(1, "day").format("YYYY-MM-DD"); // adciona um dia no from
        keys.forEach((key) => {
          //  para o values e o labls adiciona as datas do range
          dates[key][date] = 0;
        });
      }

      this.documents.forEach((doc) => {
        //para cada item em documents
        const docDate = moment(doc.createdOn).format("YYYY-MM-DD"); // faz um create on com base no item.createon
        if (dates.register.hasOwnProperty(docDate)) dates.register[docDate]++; // se no dates.register o item ja tem um create on dates.register = create on
        if (doc.hasOwnProperty("log")) {
          // se tiver a prop log
          doc.log.forEach((log) => {
            // pra cada item dentro de doc.log
            // console.log("log", log);
            const logDate = moment(log.date).format("YYYY-MM-DD"); //
            // if (dates.login.hasOwnProperty(logDate) && !currentDates.hasOwnProperty(logDate)) {
            //   currentDates[logDate] = 1
            // }
            
            if(moment(logDate,'YYYY-MM-DD').isBetween(from_Date, to_Date))
            dates.login[logDate]++;
          });
        }
      });

      keys.forEach((key) => {
        for (let n in dates[key]) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          res[key].labels.push(new Date(parseInt(nDate)));
          res[key].values.push(isNaN(dates[key][n]) ? 0 : dates[key][n]);
        }
      });
      console.log("funeldata", res);
      return res;
    },
  },

  mounted() {
    this.labels = [
      this.$t("dashboard.logins"),
      this.$t("dashboard.carts"),
      this.$t("dashboard.checkout"),
      this.$t("dashboard.payment"),
      this.$t("dashboard.placement"),
      this.$t("dashboard.finish"),
    ]
    // setTimeout(() => {
    this.loadOrders();
    this.loadAccounts();
    this.loadBI()
    // }, 1000);
  },
  watch: {
    "$i18n.locale"() {
      // location.reload()
      this.labels = [
        this.$t("dashboard.logins"),
        this.$t("dashboard.carts"),
        this.$t("dashboard.checkout"),
        this.$t("dashboard.payment"),
        this.$t("dashboard.placement"),
        this.$t("dashboard.finish"),
      ]
      this.loadOrders();
      this.loadAccounts();
    },
    "filter.date.dates": {
      deep: true,
      handler() {
        this.loadOrders();
      },
    },
    "filter.date.menu": {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.newDates = JSON.parse(JSON.stringify(this.filter.date.dates));
          }, 100);
        }
      },
    },
    selectedStore: {
      deep: true,
      haldler() {
        this.loadOrders();
      },
    },
  },
  methods: {
    calcPlanValue(plan) {
      const selectedddStoreId = this.selectedStore.id
      let value = 0;
      if (plan.simulation.length) {
        for (let sku = 0; sku < plan.simulation.length; sku++) {
          // if (plan.simulation[sku].asu.store == selectedddStoreId) {
          if (Object.keys(plan.simulation[sku].total).length) {
            if (plan.simulation[sku].total.totalSum)
              value +=
                plan.simulation[sku].total.totalSum *
                plan.simulation[sku].asu.rules.pricing.price;
            else return 0;
          } else {
            return 0;
          }
          // } else {
          //   console.log("sku", plan.simulation[sku].asu.store);
          //   return 0;
          // }
        }
      } else {
        return 0;
      }
      return value;
    },
    goToCart() {
      this.$router.replace(
        `/sales/orders?status=planning&from=${this.filter.date.dates[0]}&to=${this.filter.date.dates[1]}&group=1`
      );
    },
    goToCheckout() {
      this.$router.replace(
        `/sales/orders?status=checkout&from=${this.filter.date.dates[0]}&to=${this.filter.date.dates[1]}&group=2`
      );
    },
    goToPaid() {
      this.$router.replace(
        `/sales/orders?status=payment&from=${this.filter.date.dates[0]}&to=${this.filter.date.dates[1]}&group=2`
      );
    },
    goToPlacement() {
      this.$router.replace(
        `/sales/orders?status=placement&from=${this.filter.date.dates[0]}&to=${this.filter.date.dates[1]}&group=3`
      );
    },
    goToFinish() {
      this.$router.replace(
        `/sales/orders?status=finish&from=${this.filter.date.dates[0]}&to=${this.filter.date.dates[1]}&group=4`
      );
    },
    loadBI() {
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "bi"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot.then((docs) => {
        docs.forEach((d) => {
          if (d.data().id == 'payment')
          console.log('d', d.data())
            this.biPayment = d.data()
        })
      });

    },
    loadAccounts() {
      console.log('loading accounts...')
      this.loadingAccount = true;
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "accounts"));
      const querySnapshot = getDocs(q);
      const documents = [];
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          const computed = {
            updatedOn: moment(doc.data().updatedOn).format(
              "DD/MM/YYYY HH:mm:ss"
            ),
          };
          documents.push({ ...doc.data(), computed: computed });
        });
        this.documents = documents;
        this.loadingAccount = false;
        console.log('accounts loaded...')
      });
    },
    getWidth() {
      let box = document.querySelector(".--box");
      this.funnelWidth = box.offsetWidth + 24;
    },
    loadOrders() {
      const fromDate = moment(this.filter.date.dates[0], "YYYY-MM-DD").subtract(
        // pegaa primeira data do filtro e tira um dia
        1,
        "day"
      );
      const toDate = moment(this.filter.date.dates[1], "YYYY-MM-DD").add(
        // pega a segunda data do filtro e tira um dia
        1,
        "day"
      );

      this.loadingOtherData = true
      this.loading = true
      console.log('loading orders...')
      // Initialize Firebase
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "orders"), where('simulation', '!=', []));
      const querySnapshot = getDocs(q);
      const orders = [];
      this.getWidth();
      querySnapshot.then((docs) => {
        docs.forEach((doc) => {
          if (moment(doc.data().updatedOn).isBetween(fromDate, toDate) && doc.data().simulation.length)
            orders.push(doc.data());
        });
        this.orders = orders;
        console.log(' orders loaded.')
        this.load()
      });
    },
    load() {
      this.loading = false
      this.funnelLoading = false
      console.log('finishing....')
      const labels = [".label-2", ".label-3", ".label-4", ".label-5", ".label-6"];
      const dest = [
        "goToCart",
        "goToCheckout",
        "goToPaid",
        "goToPlacement",
        "goToFinish",
      ];
      setTimeout(() => {
        labels.forEach((label, index) => {
          console.log('this.values', this.values)
          const newDiv = document.createElement("div");
          const newDiv1 = document.createElement("div");
          let percentText = ''
          console.log(`loading percentage of index ${index}`)
          if (this.funnelData[index + 1][0]) {
            const percent = this.funnelData[index + 1][0] * 100 / this.funnelData[index]
            percentText = this.$n(percent.toFixed(1)) + '%'
          }
          else {
            percentText = '0%'
          }
          newDiv1.classList.add('--block')
          newDiv1.innerHTML = `<div class="label__percentage" style="display: block">${percentText}</div>`;
          document.querySelector(label).appendChild(newDiv1);


          newDiv.innerHTML = `<span class="v-btn__content">${this.$t(
            "common.details"
          )}</span>`;
          newDiv.style.cursor = "pointer";
          newDiv.classList.add(
            "v-btn",
            "v-btn--outlined",
            "theme--light",
            "v-size--default",
            "white--text",
            "mt-3",
            `btn-${label}`
          );
          newDiv.addEventListener("click", this[dest[index]]);
          document.querySelector(label).appendChild(newDiv);
          console.log('finished')
        });
      }, 150)

      this.loadingOtherData = true;
      const form = {
        from: this.filter.date.dates[0],
        to: this.filter.date.dates[1],
        domains: [`${this.selectedStore.url}.themediatrade.com`],
      };
      if (this.selectedStore.url == 'radioads') {
        form.domains.unshift('radioads.nextdial.com.br')
      }
      if (this.selectedStore.url == 'gruporpp') {
        form.domains.unshift('publiya.pe')
      }
      if (this.selectedStore.url == 'americatv') {
        form.domains.unshift('padi.pe')
      }
      if (this.selectedStore.url == 'transamerica') {
        form.domains.unshift('anuncie.transamericafm.com.br')
      }
      if (this.selectedStore.url == 'neooh') {
        form.domains.unshift('neoohads.com.br')
      }
      const url = `kpis/whitelabel/`;
      this.$axios.post(url, form).then((data) => {
        const res = data.data.data[0];
        const newUsers = {
          labels: [],
          values: [],
        };
        const sessions = {
          labels: [],
          values: [],
        };
        const visitors = {
          labels: [],
          values: [],
        };

        const users = {
          labels: [],
          values: [],
        };
        for (let n in res.newUsers) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          newUsers.labels.push(new Date(parseInt(nDate)));
          newUsers.values.push(res.newUsers[n]);
        }
        newUsers.labels.push("");
        newUsers.values.push(0);
        for (let n in res.sessions) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          sessions.labels.push(new Date(parseInt(nDate)));
          sessions.values.push(res.sessions[n]);
        }
        sessions.labels.push("");
        sessions.values.push(0);

        for (let n in res.visitors) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          visitors.labels.push(new Date(parseInt(nDate)));
          visitors.values.push(res.visitors[n]);
        }
        visitors.labels.push("");
        visitors.values.push(0);

        for (let n in res.users) {
          const nDate = moment(n, "YYYY-MM-DD").format("x");
          users.labels.push(new Date(parseInt(nDate)));
          users.values.push(res.users[n]);
        }
        users.labels.push("");
        users.values.push(0);

        this.result = {
          newUsers: newUsers,
          sessions: sessions,
          visitors: visitors,
          users: users,
        };
        // add the text node to the newly created div

        this.loadingOtherData = false;
        console.log('fn loaded.')
        // setTimeout(() => {

        // }, 3000);
      })
    },
    applyDate() {
      const dates = JSON.parse(JSON.stringify(this.newDates));
      this.filter.date.dates = moment(dates[0]).isBefore(dates[1])
        ? [dates[0], dates[1]]
        : [dates[1], dates[0]];

      this.filter.date.menu = false;
    },
  },
};
</script>
<style>
.svg-funnel-js .svg-funnel-js__container {
  position: relative;
  z-index: 0;
}

.svg-funnel-js .svg-funnel-js__labels {
  z-index: 0;
}

.svg-funnel-js svg {
  height: 400px !important;
  padding-top: 10px;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label:hover .label__percentage {
  color: #fff;
}

.--block {
  display: block;
  width: 100%;
}

.svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label {
  border-color: #25397533 !important;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  height: calc(50% + 21px);
  align-content: flex-start;
  transition: 0.3s all;
}

.svg-funnel-js:not(.svg-funnel-js--vertical) .svg-funnel-js__label:hover {
  background: #243875cf;
  box-shadow: 0 0 0 1px #243875;
  padding-top: 50px;
  border-radius: 2px 2px 0 0;
  color: #fff !important;
}

.svg-funnel-js__container path {
  -webkit-filter: drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255));
  filter: drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255)) drop-shadow(0 -2px 0 rgb(202, 209, 255));
  /* Similar syntax to box-shadow */
  transform: translate(0, 10px);
}

.funnels {
  box-sizing: border-box;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  color: black;
  font-weight: bold;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label:hover .label__value {
  color: #fff;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__segment-percentages {
  opacity: 0;
  display: none;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .v-btn {
  opacity: 0;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label .label__title {
  color: black;
  font-weight: bold;
  font-size: 14px;
  margin-left: 0px;
  width: 100%;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__percentage {
  color: #2196f3;
  font-weight: normal !important;
  flex: 0 0 100%;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label:hover .label__title {
  color: #fff !important;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label:hover .v-btn {
  opacity: 1;
}

.funnels .funnel .svg-funnel-js__labels .svg-funnel-js__label .percentage {
  color: #231dff !important;
}

.svg-funnel-js__subLabels {
  display: none !important;
}

.vue-funnel-graph-lib-dev {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.funnel:not(.svg-funnel-js--vertical) {
  transition: transform 0.3s ease;
}

.controls {
  display: flex;
}

/* button {
  background: #d8e7ff;
  color: #393862;
  border-radius: 4px;
  border: none;
  padding: 12px 24px;
  margin: 0 5px;
  font-size: 16px;
  outline: 0;
  cursor: pointer;
}

button:hover {
  background: #05df9d;
} */</style>
